import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Otp from "./pages/Otp/Otp";
import NewPassword from "./pages/NewPassword/NewPassword";
import Overview from "./pages/Overview/Overview";
import Profile from "./pages/Profile/Profile";
import Profilesub from "./pages/Profilesub/Profilesub";
import MerchantOverview from "./pages/MerchantOverview/MerchantOverview";
import DashboardOverviewMerchantsInformation from "./pages/DashboardOverviewMerchantsInformation/DashboardOverviewMerchantsInformation";
import MerchantSubscription from "./pages/MerchantSubscription/MerchantSubscription";

import EmployeeOverview from "./pages/EmployeeOverview/EmployeeOverview";
import DashboardSalesVPofSales from "./pages/DashboardSalesVPofSales/DashboardSalesVPofSales";
// import DashboardSalesVPofSalessss from "./pages/DashboardSalesVPofSalessss/DashboardSalesVPofSalessss";
// import DashboardSalesVPofDirectors from "./pages/DashboardSalesVPofDirectors/DashboardSalesVPofDirectors";
// import DashboardSalesVPofManager from "./pages/DashboardSalesVPofManager/DashboardSalesVPofManager";
import DashboardSalesVPofSalesRepresentative from "./pages/DashboardSalesVPofSalesRepresentative/DashboardSalesVPofSalesRepresentative";
import SalespersonInformation from "./pages/SalespersonInformation/SalespersonInformation";
import CustomerOverview from "./pages/CustomerOverview/CustomerOverview";
import DashboardCustomer2 from "./pages/DashboardCustomer2/DashboardCustomer2";
import CustomerService from "./pages/CustomerService/CustomerService";
import HRCreation from "./pages/HRCreation/HRCreation";
import OverviewHRAccountManagement from "./pages/OverviewHRAccountManagement/OverviewHRAccountManagement";
import OverviewHREditAccountManagement from "./pages/OverviewHREditAccountManagement/OverviewHREditAccountManagement";
import ViewAccountManagement from "./pages/ViewAccountManagement/ViewAccountManagement";
import Adminstrator from "./pages/Adminstrator/Adminstrator";
import DashboardMerchantsEmployees from "./pages/DashboardMerchantsEmployees/DashboardMerchantsEmployees";
import MerReceipts from "./pages/MerReceipts/MerReceipts";
import MerReceiptsUpgrade from "./pages/MerReceiptsUpgrade/MerReceipts";
import CusReceipts from "./pages/CusReceipts/CusReceipts";
import CustmReceipts from "./pages/CustmReceipts/CustmReceipts";
import CustmssReceipts from "./pages/CustmssReceipts/CustmssReceipts";
import MerSubReceipts from "./pages/MerSubReceipts/MerSubReceipts";
import MerEmpReceipts from "./pages/MerEmpReceipts/MerEmpReceipts";
import CustmssmerReceipts from "./pages/CustmssmerReceipts/CustmssmerReceipts";


import PrivateRoute from "./Utils/PrivateRoute";
import PrivateLoginRoute from "./Utils/PrivateLoginRoute";

import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact element={<PrivateLoginRoute />}>
            <Route path="/" element={<Login />} />

            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route path="/otp" element={<Otp />} />

            <Route path="/new-password" element={<NewPassword />} />
          </Route>
          <Route exact element={<PrivateRoute />}>
            <Route path="/overview" element={<Overview />} />

            <Route path="/profile" element={<Profile />} />

            <Route path="/profile-sub" element={<Profilesub />} />

            <Route path="/hr-creation" element={<HRCreation />} />
            <Route path="/create-account" element={<OverviewHRAccountManagement />} />

            <Route path="/edit-account/:id" element={<OverviewHREditAccountManagement />} />

            <Route path="/merchant-overview" element={<MerchantOverview />} />
            <Route path="/dashboard-overview-merchants-information" element={<DashboardOverviewMerchantsInformation />} />
            <Route path="/merchant-subscription/:id" element={<MerchantSubscription />} />


            <Route path="/employee-overview" element={<EmployeeOverview />} />
            <Route path="/dashboard-sales-vp-of-sales/:id" element={<DashboardSalesVPofSales />} />

            <Route path="/dashboard-sales-vp-of-sales-representative" element={<DashboardSalesVPofSalesRepresentative />} />
            <Route path="/salesperson-information/:id" element={<SalespersonInformation />} />

            <Route path="/customer-overview" element={<CustomerOverview />} />
            <Route path="/dashboard-customer2/:id" element={<DashboardCustomer2 />} />

            <Route path="/customer-service" element={<CustomerService />} />

            <Route path="/view-account-management" element={<ViewAccountManagement />} />

            <Route path="/adminstrator" element={<Adminstrator />} />
            <Route path="/dashboard-merchants-employees/:id/:store_id" element={<DashboardMerchantsEmployees />} />

            <Route path="/mer-receipts-new/:id/:store_id/:subscription_transaction_id" element={<MerReceiptsUpgrade />} />
            <Route path="/mer-receipts/:id/:store_id/:subscription_transaction_id" element={<MerReceipts />} />
            <Route path="/cus-receipts/:order_id/:id" element={<CusReceipts />} />
            <Route path="/custm-receipts/:order_id/:id" element={<CustmReceipts />} />
            <Route path="/custmss-receipts/:order_id/:id" element={<CustmssReceipts />} />

            <Route path="/mer-subscription-receipts/:id/:store_id/:subscription_transaction_id" element={<MerSubReceipts />} />

            <Route path="/mer-employee-receipts/:id/:store_id/:employee_transaction_id" element={<MerEmpReceipts />} />

            <Route path="/custmssmer-receipts/:order_id/:id" element={<CustmssmerReceipts />} />

          </Route>
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}
export default App;